<template>
  <div>
    <v-form ref="addNoteDialogForm" :lazy-validation="false">
      <v-dialog v-model="SHOW" width="500" persistent>
        <v-card>
          <div class="header-icon-wrapper">
            <v-icon color="blue darken-2">mdi-pencil</v-icon>
          </div>
          <div class="wrapper-title">
            <h3>{{ $t("addNote") }}</h3>
          </div>
          <div class="wrapper-text">
            <v-card-text>{{ $t("addNoteDialogSubtext") }}</v-card-text>
          </div>
          <v-card-text>
            <v-select v-model="selectedCategory" :items="categories" :label="$t('category')" item-text="value" item-value="name" :no-data-text="$t('no_data_found')" :rules="[rules.categoryRequired]"></v-select>
            <v-text-field v-if="selectedCategory != null  && selectedCategory === 'NOTE_CATEGORY_OTHER'" v-model="description" :label="$t('noteDetail')" :maxlength="1000" :counter="1000" :rules="[rules.descriptionRequired]"></v-text-field>
          </v-card-text>
          <v-divider class="main-action-process-list-divider"></v-divider>
          <div class="process-main-actions">
            <v-btn large outlined color="primary" @click="onClickCancel">{{ $t("cancel") }}
            </v-btn>
            <v-btn large color="primary" @click="onClickAddNote" :disabled="
                isRetrievingCategories ||
                isAddingNoteInProgress ||
                selectedCategory === 0
              " :loading="isRetrievingCategories">{{ $t("addNote") }}</v-btn>
          </div>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import AddNoteDialog from "./mixin/AddNoteDialog";

export default {
  mixins: [AddNoteDialog]
};
</script>
<style lang="scss" scoped>
$primaryColor: #3fa2f7;

.header-icon-wrapper {
  text-align: center;
  padding-top: 20px;
  .v-icon {
    font-size: 3rem;
    padding: 25px;
    border-radius: 50%;
    border: 4px solid #3fa2f7;
  }
}
.wrapper-title {
  text-align: center;
  margin-top: 5%;
  color: $primaryColor;
}
.wrapper-text {
  text-align: center;
  color: $primaryColor;
}
.main-action-process-list-divider {
  margin-bottom: 5%;
}
.process-main-actions {
  text-align: center;
  padding-bottom: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/AddNoteDialog.vue